import * as types from '../mutations-types'

const state = {
  fromRoute: null,
  officialZonesHome: {},
  firefightersPath: [],
  firefightersSelected: [],
  empasPath: [],
  empasSelected: [],
  neighborhoodsPath: [],
  communesPath: [],
  quadrantsPath: [],
  stationsPath: [],
  districtsPath: [],
  neighborhoodsSelected: [],
  communesSelected: [],
  quadrantsSelected: [],
  stationsSelected: [],
  districtsSelected: []
}

const getters = {
  fromRoute: state => state.fromRoute,
  officialZonesHome: state => state.officialZonesHome,
  firefightersPath: state => state.firefightersPath,
  firefightersSelected: state => state.firefightersSelected,
  empasPath: state => state.empasPath,
  empasSelected: state => state.empasSelected,
  neighborhoodsPath: state => state.neighborhoodsPath,
  communesPath: state => state.communesPath,
  quadrantsPath: state => state.quadrantsPath,
  stationsPath: state => state.stationsPath,
  districtsPath: state => state.districtsPath,
  neighborhoodsSelected: state => state.neighborhoodsSelected,
  communesSelected: state => state.communesSelected,
  quadrantsSelected: state => state.quadrantsSelected,
  stationsSelected: state => state.stationsSelected,
  districtsSelected: state => state.districtsSelected
}

const mutations = {
  [types.SAVE_FROM_ROUTE](state, value) {
    state.fromRoute = value
  },
  [types.LOAD_OFFICIAL_ZONES_HOME](state) {
    state.neighborhoodsPath = state.officialZonesHome.neighborhoodsPath
    state.neighborhoodsSelected = state.officialZonesHome.neighborhoodsSelected
    state.communesPath = state.officialZonesHome.communesPath
    state.communesSelected = state.officialZonesHome.communesSelected
    state.quadrantsPath = state.officialZonesHome.quadrantsPath
    state.quadrantsSelected = state.officialZonesHome.quadrantsSelected
    state.stationsPath = state.officialZonesHome.stationsPath
    state.stationsSelected = state.officialZonesHome.stationsSelected
    state.districtsPath = state.officialZonesHome.districtsPath
    state.districtsSelected = state.officialZonesHome.districtsSelected
    state.firefightersPath = state.officialZonesHome.firefightersPath
    state.firefightersSelected = state.officialZonesHome.firefightersSelected
    state.empasPath = state.officialZonesHome.empasPath
    state.empasSelected = state.officialZonesHome.empasSelected

    state.officialZonesHome = {}
  },
  [types.SAVE_OFFICIAL_ZONES_HOME](state) {
    state.officialZonesHome = {
      neighborhoodsPath: state.neighborhoodsPath,
      neighborhoodsSelected: state.neighborhoodsSelected,
      communesPath: state.communesPath,
      communesSelected: state.communesSelected,
      quadrantsPath: state.quadrantsPath,
      quadrantsSelected: state.quadrantsSelected,
      stationsPath: state.stationsPath,
      stationsSelected: state.stationsSelected,
      districtsPath: state.districtsPath,
      districtsSelected: state.districtsSelected,
      firefightersPath: state.firefightersPath,
      firefightersSelected: state.firefightersSelected,
      empasPath: state.empasPath,
      empasSelected: state.empasSelected
    }
  },
  [types.SET_SELECTED_OFFICIAL_ZONE](state, payload) {
    state[`${payload.from}Selected`] = payload.value
  },
  [types.CLEAR_ALL_OFFICIAL_POLYGONS](state) {
    state.firefightersPath = []
    state.firefightersSelected = []
    state.empasPath = []
    state.empasSelected = []
    state.neighborhoodsPath = []
    state.communesPath = []
    state.quadrantsPath = []
    state.stationsPath = []
    state.districtsPath = []
    state.neighborhoodsSelected = []
    state.communesSelected = []
    state.quadrantsSelected = []
    state.stationsSelected = []
    state.districtsSelected = []
  },
  [types.CLEAR_SELECTED_OFFICIAL_ZONES](state, from) {
    state[`${from}Selected`] = []
  },
  [types.CLEAR_PATH_OFFICIAL_ZONES](state, from) {
    state[`${from}Path`] = []
  },
  [types.SET_DISPLAY_OFFICIAL_ZONE](state, payload) {
    state[`${payload.from}Path`].push(payload.polygon)
  }
}

const actions = {
  saveFromRoute({commit}, from) {
    // console.log('saveFromRoute', from)
    commit(types.SAVE_FROM_ROUTE, from)
  },
  fetchOfficialZonesHome({commit}) {
    commit(types.LOAD_OFFICIAL_ZONES_HOME)
  },
  saveOfficialZonesHome({commit}) {
    commit(types.SAVE_OFFICIAL_ZONES_HOME)
  },
  setSelectedOfficialZone({commit}, payload) {
    commit(types.SET_SELECTED_OFFICIAL_ZONE, payload)
  },
  clearAllOfficialPolygons({commit}) {
    commit(types.CLEAR_ALL_OFFICIAL_POLYGONS)
  },
  clearOfficialZones({commit}, from) {
    commit(types.CLEAR_SELECTED_OFFICIAL_ZONES, from)
    commit(types.CLEAR_PATH_OFFICIAL_ZONES, from)
  },
  displayOfficialZones({commit, state, rootGetters}, from) {
    if (state[`${from}Selected`] !== undefined || state[`${from}Selected`] !== null) {
      commit(types.CLEAR_PATH_OFFICIAL_ZONES, from)

      state[`${from}Selected`].forEach(element => {
        let elementNames = [element]

        const zoneFromIn = from === 'communes' ? 'comunes' : from

        const zoneFromFilters = `get${zoneFromIn.charAt(0).toUpperCase()}${zoneFromIn.slice(1)}`

        if ('communes' === from) {
          if ('San Javier' === element) {
            elementNames = ['San Javier A', 'San Javier B']
          }

          if ('San Cristóbal' === element) {
            elementNames = ['San Cristóbal A', 'San Cristóbal B']
          }
        }

        elementNames.forEach(elementName => {
          const zone = rootGetters[`filters/${zoneFromFilters}`].filter(item => item.name === elementName)

          if (0 < zone.length) {
            const polygon = window.google.maps.geometry.encoding.decodePath(zone[0].geostring)

            const payload = { from, polygon }

            commit(types.SET_DISPLAY_OFFICIAL_ZONE, payload)
          }
        })
      })
    } else {
      commit(types.CLEAR_SELECTED_OFFICIAL_ZONES, from)
      commit(types.CLEAR_PATH_OFFICIAL_ZONES, from)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/officialZones.js